import { AirSelectedItineraryResponseManager } from 'obt-common';

import useGetAirSelectedItineraryResponse from './useGetAirSelectedItineraryResponse';

function useAirSelectedItineraryManager(): AirSelectedItineraryResponseManager {
  const airSelectedItineraryResponse = useGetAirSelectedItineraryResponse();

  const airSelectedItineraryResponseManager = new AirSelectedItineraryResponseManager(airSelectedItineraryResponse);

  return airSelectedItineraryResponseManager;
}

export default useAirSelectedItineraryManager;
